<div class="method-switcher clickable" tappable (click)="openMethodSelectionModal()">
  <i class="fas fa-exchange-alt"></i> {{ 'CHANGE' | translate }}
</div>
